import * as React from 'react';
import styled from 'styled-components';
import { ReactEditor, useSlateStatic } from 'slate-react';
import { Editor } from 'slate';

import { LinkSettingEnum } from '@doltech/utils/lib/constants';
import { colorsV2 } from '../../../colors-v2';
import { ELEMENT_HYPER_LINK } from './defaults';

const HyperLink = styled.a`
  color: ${colorsV2.blue100};
  text-decoration-line: underline;

  &:hover {
    color: ${colorsV2.blue60};
    text-decoration-line: underline;
  }
`;

export const renderHyperLinkElement =
  (_options) =>
  ({ attributes, children, element }) => {
    const editor = useSlateStatic();
    if (element.type === ELEMENT_HYPER_LINK) {
      const isNofollow = element?.linkSettings?.includes(LinkSettingEnum.NO_FOLLOW);
      const isNewTab = element?.linkSettings?.includes(LinkSettingEnum.OPEN_NEW_TAB);
      const path = ReactEditor.findPath(editor as any, element);

      return (
        <HyperLink
          onClick={(e) => {
            // need to stopPropagation to prevent parent block when click a href
            e.stopPropagation();
            editor.selection = Editor.range(editor, path);
          }}
          className="hyper-link-element"
          {...attributes}
          href={element.url}
          rel={isNofollow ? 'nofollow' : ''}
          target={isNewTab ? '_blank' : '_self'}
        >
          {children}
        </HyperLink>
      );
    }
    return null;
  };
